import api from '../api';
import type { StudentProfileFields } from '../../components/admin/StudentProfileSections';

function data<T>(res: { data: { data: T } }): T {
  return res.data.data;
}

// GET /admin/users?role=student listing goes through useServerTable directly
// (see StudentsManager) for standard search/sort/pagination — these cover
// the row actions: block/activate and reset password (mismos endpoints y
// patrón que staffUsersClient, con role: 'student').
export type BulkCreateRow = {
  name: string
  email: string
  phone?: string | null
  country?: string | null
  profile?: StudentProfileFields
}

export type BulkCreateResult = {
  created: { id: string; name: string; email: string }[];
  skipped: { email: string; error: string }[];
};

export type BulkDeleteResult = {
  deleted: string[];
  skipped: { id: string; reason: string }[];
};

export const studentsAdmin = {
  updateStatus: (id: string, isActive: boolean) =>
    api.patch<{ data: { user: { id: string; isActive: boolean } } }>(`/admin/users/${id}`, { isActive }).then(data),

  resetPassword: (id: string) =>
    api.post<{ data: { tempPassword: string } }>(`/admin/users/${id}/reset-password`).then(data),

  // csv-import-workflows-and-location-fields: returns a jobId — poll
  // GET /import-jobs/:id (see lib/importJobs.ts) for the created/skipped result.
  bulkCreate: (users: BulkCreateRow[]) =>
    api.post<{ data: { jobId: string } }>(`/admin/users/bulk`, { users }).then(data),

  // Restringido a role === 'admin' en el backend (requireRole('admin'), no un
  // permiso granular) — ver el docstring de la ruta en platforms/api/admin.ts.
  bulkDelete: (ids: string[]) =>
    api.post<{ data: BulkDeleteResult }>(`/admin/users/bulk-delete`, { ids }).then(data),
};
